import type { ReactElement } from 'react'
import type { ConnectionStatus } from '../stores/session'

export interface ConnectionBadgeProps {
  readonly status: ConnectionStatus
  readonly error?: string | null
}

const LABELS: Record<ConnectionStatus, string> = {
  idle: '未连接',
  signaling: '等待对方加入',
  connecting: '正在建立通道',
  connected: '已连接',
  failed: '连接失败',
  closed: '连接已断开',
}

const TONES: Record<ConnectionStatus, string> = {
  idle: 'border-white/20 text-white/60',
  signaling: 'border-warning/50 text-warning',
  connecting: 'border-warning/50 text-warning',
  connected: 'border-accent/50 text-accent',
  failed: 'border-danger/60 text-danger',
  closed: 'border-white/20 text-white/60',
}

export function ConnectionBadge({ status, error }: ConnectionBadgeProps): ReactElement {
  return (
    <span className="inline-flex flex-col items-start gap-1">
      <span
        className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs whitespace-nowrap ${TONES[status]}`}
      >
        <span className="size-1.5 rounded-full bg-current" aria-hidden="true" />
        {LABELS[status]}
      </span>
      {error ? <span className="text-xs text-danger">{error}</span> : null}
    </span>
  )
}
